"use client";
import { useGroupLabel } from "../group/group-label.js";
import { createElement, createHook, forwardRef } from "@ariakit/react-utils";
//#region src/composite/composite-group-label.tsx
const TagName = "div";
/**
* Returns props to create a `CompositeGroupLabel` component. This hook must be
* used in a component that's wrapped with `CompositeGroup` so the
* `aria-labelledby` prop is properly set on the composite group element.
* @see https://ariakit.com/components/composite
* @example
* ```jsx
* // This component must be wrapped with CompositeGroup
* const props = useCompositeGroupLabel();
* <Role {...props}>Label</Role>
* ```
*/
const useCompositeGroupLabel = createHook(function useCompositeGroupLabel({ store, ...props }) {
	props = useGroupLabel(props);
	return props;
});
/**
* Renders a label in a composite group. This component must be wrapped with
* [`CompositeGroup`](https://ariakit.com/reference/composite-group) so the
* `aria-labelledby` prop is properly set on the group element.
* @see https://ariakit.com/components/composite
* @example
* ```jsx {4}
* <CompositeProvider>
*   <Composite>
*     <CompositeGroup>
*       <CompositeGroupLabel>Label</CompositeGroupLabel>
*       <CompositeItem>Item 1</CompositeItem>
*       <CompositeItem>Item 2</CompositeItem>
*     </CompositeGroup>
*   </Composite>
* </CompositeProvider>
* ```
*/
const CompositeGroupLabel = forwardRef(function CompositeGroupLabel(props) {
	return createElement(TagName, useCompositeGroupLabel(props));
});
//#endregion
export { CompositeGroupLabel, useCompositeGroupLabel };

//# sourceMappingURL=composite-group-label.js.map